<template>
  <div class="questionBankDetails">
    <!--庆祝特效-->
    <div v-if="showeffect" class="celebration">
      <div class="celebration-wrapper">
        <div class="grant-top" v-if="grantStarCoinInfo.state === 1 && grantStarCoinInfo.starNum">
          <img src="@/assets/image/stuUI/grantStarCoinTopBg.png" alt="">
          <span class="grant-num">+{{grantStarCoinInfo.starNum||0}}</span>
        </div>
        <img :src="effect_imgurl" alt="Celebration Image" class="celebration-effect" />
      </div>
    </div>

    <div class="topTitle clearfix">
      <div class="fl" v-if="$route.query.type1 === 'Gameproblem'">
        <span style="cursor: pointer;" @click="gobackproblem">返回题目</span> /
        <span style="font-weight:bold;color:#606266;">{{
          detailsFrom.code + "\xa0" + detailsFrom.title
        }}</span>
      </div>
      <div class="fl" v-if="$route.query.type1 === 'game1'">
        <span style="cursor: pointer;" @click="goback1">返回比赛</span> /
        <span style="font-weight:bold;color:#606266;">{{
          detailsFrom.code + "\xa0" + detailsFrom.title
        }}</span>
      </div>
      <div style="cursor: pointer;" class="fl" v-if="$route.query.type1 === 'problem2'">
        <el-page-header @back="goback2" :content="detailsFrom.code + '\xa0' + detailsFrom.title">
        </el-page-header>
      </div>
      <div style="cursor: pointer;" class="fl" v-if="$route.query.type1 === 'problem'">
        <el-page-header @back="goback">
          <template #content>
            <span style="color:#303133;">
              {{ detailsFrom.code + "\xa0" + detailsFrom.title }}
            </span>
          </template>
        </el-page-header>
      </div>
      <div style="cursor: pointer;" class="fl" v-if="$route.query.type1 === 'tidan'">
        <span @click="goback">返回题单</span> /
        <span style="font-weight:bold;color:#606266;">{{
          detailsFrom.code + "\xa0" + detailsFrom.title
        }}</span>
      </div>
      <div style="cursor: pointer;" class="fl" v-if="$route.query.type1 === 'tuandui'">
        <span @click="goback">返回团队</span> /
        <span style="font-weight:bold;color:#606266;">{{
          detailsFrom.code + "\xa0" + detailsFrom.title
        }}</span>
      </div>
      <div style="cursor: pointer;" class="fl" v-if="$route.query.type1 === 'tuanduiStu'">
        <span @click="goback">返回团队</span> /
        <span style="font-weight:bold;color:#606266;">{{
          detailsFrom.code + "\xa0" + detailsFrom.title
        }}</span>
      </div>

      <div style="cursor: pointer;" class="fl" v-if="$route.query.type1 === 'tuanduitidan'">
        <span @click="goback">返回团队</span> /
        <span style="font-weight:bold;color:#606266;">{{
          detailsFrom.code + "\xa0" + detailsFrom.title
        }}</span>
      </div>
      <div style="cursor: pointer;" class="fl" v-if="$route.query.type1 === 'recordOJ'">
        <el-page-header @back="gobackrecordOJ" :content="detailsFrom.code + '\xa0' + detailsFrom.title">
        </el-page-header>
      </div>

      <div class="fr">
        <div class="clearfix">
          <div class="fl" style="cursor:pointer;" @click="ShowChatGPT">
            <el-image style="margin-top:-2px;width: 24px; height: 24px;border:1px solid #ccc;border-radius: 20px;padding:1px" src="https://wugecdn.steam.fun/resources/static/p-1-1.png" fit="cover"></el-image>

            <span style="color:#333;margin-left:4px;margin-right:30px;float:right;font-weight:bold">
              Ai助手・P仔</span>
          </div>

          <div class="fl" style="cursor: pointer;" @click="goTopicAnalysis">
            <svg t="1660791893749" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2463" width="20" height="20">
              <path d="M0 0m219.428571 0l585.142858 0q219.428571 0 219.428571 219.428571l0 585.142858q0 219.428571-219.428571 219.428571l-585.142858 0q-219.428571 0-219.428571-219.428571l0-585.142858q0-219.428571 219.428571-219.428571Z" fill="#007AFF" p-id="2464"></path>
              <path d="M512 256c141.385143 0 256 114.614857 256 256 0 59.794286-20.48 114.779429-54.838857 158.354286L713.142857 749.714286a18.285714 18.285714 0 0 1-18.285714 18.285714H512c-141.385143 0-256-114.614857-256-256s114.614857-256 256-256z m-1.133714 109.714286c-7.643429 0-14.08 1.517714-19.291429 4.534857a37.065143 37.065143 0 0 0-12.617143 11.885714c-3.2 4.864-6.217143 11.008-9.033143 18.413714l-5.979428 15.725715-1.28 3.291428-70.582857 183.716572a247.222857 247.222857 0 0 0-6.217143 17.188571 40.96 40.96 0 0 0-1.865143 11.958857c0 6.692571 2.706286 12.672 8.100571 17.938286 5.394286 5.284571 11.593143 7.917714 18.633143 7.917714 8.283429 0 14.244571-2.468571 17.883429-7.424 3.273143-4.461714 7.149714-12.653714 11.648-24.557714l1.517714-4.114286 13.165714-36.278857h112.201143l13.165715 35.510857c1.773714 4.388571 3.876571 9.435429 6.326857 15.158857 2.432 5.723429 4.736 9.965714 6.857143 12.726858 2.139429 2.779429 4.772571 4.955429 7.917714 6.582857 3.126857 1.590857 6.893714 2.395429 11.282286 2.395428 7.533714 0 13.970286-2.742857 19.309714-8.210285 5.321143-5.467429 7.990857-11.483429 7.990857-18.029715 0-5.668571-2.285714-14.445714-6.857143-26.258285l-1.609143-4.041143-72.100571-182.582857a920.137143 920.137143 0 0 0-8.374857-21.888 82.56 82.56 0 0 0-8.100572-15.36 37.796571 37.796571 0 0 0-12.617143-11.666286c-5.193143-3.017143-11.702857-4.534857-19.474285-4.534857z m0.731428 54.857143L548.571429 548.571429h-82.285715l45.293715-128z" fill="#FFFFFF" p-id="2465"></path>
            </svg>

            <span style="color:#333;float:right;margin-left:5px;font-weight:bold">
              查看解析</span>
          </div>
        </div>
      </div>
    </div>
    <div class=" main">
      <el-row>
        <el-col :span="num">
          <div class="main-left">
            <div class="main_top">
              <ul class="clearfix">
                <li>
                  <div class="txt1">提交</div>
                  <div class="txt2">{{ detailsFrom.totalSubmissionNum }}</div>
                </li>
                <li>
                  <div class="txt1">通过</div>
                  <div class="txt2">{{ detailsFrom.acceptSubmissionNum }}</div>
                </li>
                <li>
                  <div class="txt1">时间限制</div>
                  <div class="txt2">{{ detailsFrom.time_limit }}ms</div>
                </li>
                <li>
                  <div class="txt1">内存限制</div>
                  <div class="txt2">{{ detailsFrom.memory_limit }}Mb</div>
                </li>
                <li @click="handleFullScreen" style="cursor: pointer;">
                  <div class="txt1">全屏</div>
                  <div class="txt2 el-icon-full-screen"></div>
                </li>
              </ul>
            </div>
            <div class="main_cotton" v-if="detailsFrom.description_show_type === 1">
              <div>
                <div class="txt4">描述</div>

                <div style="font-size: 12pt;" v-html="detailsFrom.description"></div>
              </div>
              <div>
                <div class="txt4">输入描述</div>

                <div style="font-size: 12pt;" v-html="detailsFrom.input_description"></div>
              </div>
              <div>
                <div class="txt4">输出描述</div>
                <div style="font-size: 12pt;" v-html="detailsFrom.output_description"></div>
              </div>

              <div class="txt4">输入输出样例</div>

              <div v-for="(sample, index) in samples" :key="index">
                <div class="flex-container sample clearfix">
                  <span class="sample-input fl">
                    <span class="title">输入样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags1" :data-clipboard-text="sample.input" @click="copy" size="mini">复制</el-tag></span>
                    <pre class="language-c" v-if="language == 0"><code>{{ sample.input }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.input }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.input }}</code></pre>
                  </span>
                  <span class="sample-input fl">
                    <span class="title">输出样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;">
                      <el-tag class="tags2" :data-clipboard-text="sample.output" @click="copy1" size="mini">复制</el-tag>
                    </span>
                    <pre class="language-c" v-if="language == 0"><code>{{ sample.output }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.output }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.output }}</code></pre>
                  </span>
                </div>
              </div>

              <div>
                <div class="txt4" v-if="detailsFrom.hint">提示</div>

                <div style="font-size: 12pt;" v-html="detailsFrom.hint"></div>
              </div>
              <div>
                <div v-if="
                    detailsFrom.attachment_url === null ||
                      detailsFrom.attachment_url === ''
                  "></div>
                <div v-else>
                  <div class="txt4">附件下载</div>
                  <div style="margin-top: 20px;">
                    <el-link @click="DownloadFile">{{ zipTxt }}</el-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="main_cotton" v-if="detailsFrom.description_show_type === 2">
              <div>
                <div class="txt4">描述</div>
                <mavon-editor :style="{ 'min-height': height }" preview-background="#fff" v-model="detailsFrom.md_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>
              <div>
                <div class="txt4">输入描述</div>
                <mavon-editor :style="{ 'min-height': height }" preview-background="#fff" v-model="detailsFrom.md_input_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>
              <div>
                <div class="txt4">输出描述</div>
                <mavon-editor :style="{ 'min-height': height }" preview-background="#fff" v-model="detailsFrom.md_output_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>

              <div class="txt4">输入输出样例</div>

              <div v-for="(sample, index) in samples" :key="index">
                <div class="flex-container sample clearfix">
                  <span class="sample-input fl">
                    <span class="title">输入样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags1" :data-clipboard-text="sample.input" @click="copy" size="mini">复制</el-tag></span>

                    <!-- <p class="title">输入样例1</p> -->

                    <pre class="language-c" v-if="language == 0"><code>{{ sample.input }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.input }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.input }}</code></pre>
                  </span>
                  <span class="sample-input fl">
                    <span class="title">输出样例 {{ index + 1 }}</span>
                    <span class="title" style="margin-left: 15px;cursor: pointer;">
                      <el-tag class="tags2" :data-clipboard-text="sample.output" @click="copy1" size="mini">复制</el-tag>
                    </span>

                    <pre class="language-c" v-if="language == 0"><code>{{ sample.output }}</code></pre>
                    <pre class="language-cpp" v-if="language == 1"><code>{{ sample.output }}</code></pre>
                    <pre class="language-python" v-if="language == 2"><code>{{ sample.output }}</code></pre>
                  </span>
                </div>
              </div>
              <div class="txt4">提示</div>
              <mavon-editor :style="{ 'min-height': height }" style="background-color: #fff;" preview-background="#fff" v-model="detailsFrom.md_hint" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              <div v-if="
                  detailsFrom.attachment_url === null ||
                    detailsFrom.attachment_url === ''
                "></div>
              <div v-else>
                <div class="txt4">附件下载</div>
                <div style="margin-top: 20px;">
                  <el-link @click="DownloadFile">{{ zipTxt }}</el-link>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="num2">
          <div class="main-right">
            <CodeMirror class="editor" :style="{ height: scrollerHeight }" :code="code" :arr1="arr1" :language="language" @cdata="oncdata" @changeLang="onChangeLang" @handleFullScreen1="handleFullScreen1">
            </CodeMirror>

            <div class="Console" v-if="isshow2">
              <el-tabs type="border-card" v-model="activeName1">
                <el-tab-pane label="测试用例" name="first1">
                  <el-input type="textarea" resize="none" v-model="desc" :autosize="{ minRows: 5, maxRows: 5 }"></el-input>
                </el-tab-pane>
                <el-tab-pane label="代码执行结果" name="second1">
                  执行结果:
                  <div v-if="result1 === 0">
                    <div style="margin-top:10px">
                      <el-alert style="white-space:pre" v-html="output" type="success">
                      </el-alert>
                    </div>
                  </div>
                  <span v-if="result1 === -1">程序输出不正确</span>
                  <span style="color: #8F2624;" v-if="result1 === 1">时间超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 2">时间超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 3">内存超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 4">程序运行错误</span>
                  <span style="color: #8F2624;" v-if="result1 === 5">系统错误</span>
                  <!-- <span style="color: #8F2624;" v-if="result1 === 5">系统错误</span> -->
                  <span style="color: #8F2624;" v-if="result1 === -2">编译失败</span>
                  <span style="color: #8F2624;" v-if="result1 === 6">等待测评</span>
                  <span style="color: #8F2624;" v-if="result1 === 7">测评中</span>
                  <span v-if="result1 === 8">部分输出正确</span>
                  <div v-if="result1 === -2 ? true : false" style="margin-top:10px" class="weeor">
                    <div style="border:1px solid #F2F6FC;padding:10px;border-radius:10px;margin-bottom:5px;color:red;" v-for="item in errorlist" :key="item.index">
                      <span style="margin-bottom:10px;">{{ item }}</span>
                      <br />
                    </div>

                    <div style="margin-top:20px;display: inline-block;cursor: pointer;" @click="HelpAi">
                      <el-image style="float:left;margin-top:-2px;width: 24px; height: 24px;border:1px solid #ccc;border-radius: 20px;padding:1px" src="https://wugecdn.steam.fun/resources/static/p-1-1.png" fit="cover"></el-image>

                      <span style="color:#333;margin-left:8px;margin-right:30px;float:left;font-weight:bold;">
                        Ai错误诊断</span>
                    </div>
                    <!--
                    <div
                      v-if="auto_error"
                      style="border:1px solid #F2F6FC;padding:10px;border-radius:10px;margin-top:10px;"
                      v-html="error_message"
                    ></div>
-->
                    <mavon-editor v-if="auto_error" :style="{ 'min-height': '0px', 'margin-top': '20px' }" preview-background="transparent" v-model="error_message" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div :style="{ margin: marginTop }">
              <div class="clearfix" style="position: relative; z-index: 10;">
                <div class="fl">
                  <el-button v-if="$route.query.type1 === 'game1' ? true : false" size="small" type="primary" @click="submit('submit')" :disabled="disabled1" :loading="disabled2">提交代码</el-button>

                  <el-button v-if="$route.query.type1 != 'game1' ? true : false" type="text" style="color:#606266;margin-right:10px" size="small" @click="Console" :disabled="disabled1">控制台
                    <span v-if="isshow2 === false" class="el-icon-caret-bottom"></span>
                    <span v-else class="el-icon-caret-top"></span>
                  </el-button>
                  <el-dropdown trigger="click" v-if="isshow2" class="select">
                    <span class="el-dropdown-link" ref="ellink">
                      <span style="font-size:12px; cursor: pointer;color:#0A84FF">填入示例<i class="el-icon-arrow-down el-icon--right" /></span>
                    </span>
                    <el-dropdown-menu slot="dropdown" align="center">
                      <el-dropdown-item v-for="(item, index) in samples" :key="index" style="padding:0 10px 0 10px;text-align: left;" @click.native="ChangeSamples(item.input)">
                        样例{{ index + 1 }}
                        <span style="margin-left:10px;color:#ccc">{{
                          item.input
                        }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-if="$route.query.type1 === 'game1' ? true : false">
                  <div class="fl main_msg" style="margin-left:20px;margin-top:4px;" v-if="
                      $route.query.rule_type != 2 && !disabled1 && code !== ''
                    ">
                    <el-tag size="mini" v-if="result === -1" type="warning">程序输出不正确</el-tag>
                    <el-tag size="mini" v-if="result === 0" effect="dark" type="success">恭喜你通过了这道题!</el-tag>
                    <el-tag size="mini" v-if="result === 1" type="warning">时间超限</el-tag>
                    <el-tag size="mini" v-if="result === 2" type="warning">时间超限</el-tag>
                    <el-tag size="mini" v-if="result === 3" type="warning">内存超限</el-tag>
                    <el-tag size="mini" v-if="result === 4" type="warning">程序运行错误</el-tag>
                    <el-tag size="mini" v-if="result === 5" type="warning">系统错误</el-tag>
                    <el-tag size="mini" v-if="result === -2" type="warning">编译失败</el-tag>
                    <el-tag size="mini" v-if="result === 6" type="warning">等待测评</el-tag>
                    <el-tag size="mini" v-if="result === 7" type="warning">测评中</el-tag>
                    <el-tag size="mini" v-if="result === 8" type="success">部分输出正确</el-tag>
                  </div>
                </div>
                <div v-if="
                    $route.query.rule_type === 2 && !disabled1 && code !== ''
                  " class="fl main_msg" style="margin-left:20px;margin-top:4px;">
                  <el-tag size="mini" v-if="result != null" effect="dark" type="success">提交成功!</el-tag>
                </div>
                <div class="fl" v-if="isshow1">
                  <div style="margin-top:4px">
                    <el-tag v-if="$route.query.rule_type === 3 ? true : false" size="mini">提交次数:{{
                        ioiUserCoutestProblemSubmissionCount
                      }}次</el-tag>
                  </div>
                </div>
                <div class="fr">
                  <el-button-group style="margin-right:20px">
                    <el-button size="small" type="" @click="redo" :disabled="disabled1">重做</el-button>
                    <el-button size="small" type="" style="margin-left:0px" :disabled="disabled1" @click="GoSubmitRecords">记录</el-button>
                    <el-button size="small" type="primary" style="margin-left:0px" :disabled="disabled1" :loading="disabled2" @click="submit('save')">保存</el-button>
                  </el-button-group>
                  <el-button-group>
                    <el-button v-if="$route.query.type1 != 'game1' ? true : false" size="small" type="" @click="test" :disabled="disabled1" :loading="disabled3">测试</el-button>
                    <el-button v-if="$route.query.type1 != 'game1' ? true : false" size="small" type="primary" @click="submit('submit')" :disabled="disabled1" :loading="disabled2">提交代码</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <el-dialog title="编译失败" :visible.sync="dialogVisible" width="40%" :destroy-on-close="true">
              <div style="max-height:50vh;overflow-y:scroll;">
                <div style="border:1px solid #F2F6FC;padding:10px;border-radius:10px;margin-bottom:5px;color:red;" v-for="item in errorlist" :key="item.index">
                  <span style="margin-bottom:10px;">{{
                    "【错误】" + item
                  }}</span>
                </div>

                <div style="margin-top:20px;display: inline-block;cursor: pointer;" @click="HelpAi">
                  <el-image style="float:left;margin-top:-2px;width: 24px; height: 24px;border:1px solid #ccc;border-radius: 20px;padding:1px" src="https://wugecdn.steam.fun/resources/static/p-1-1.png" fit="cover"></el-image>

                  <span style="color:#333;margin-left:8px;margin-right:30px;float:left;font-weight:bold;">
                    Ai错误诊断</span>
                </div>

                <mavon-editor v-if="auto_error" :style="{ 'min-height': '0px', 'margin-top': '20px' }" preview-background="transparent" v-model="error_message" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </div>
            </el-dialog>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-drawer :with-header="false" :visible.sync="drawer" direction="rtl" size="86%">
      <div class="clearfix">
        <div class="fl" style="width:calc(50% - 10px)">
          <div style="padding:20px;padding-right: 10px;">
            <el-table ref="subMitList" highlight-current-row size="mini" :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: 'white', color: '#909399' }" @cell-click="lookDetil">
              <el-table-column type="index" label="序号">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + 1 + (page_no - 1) * page_size
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="语言">
                <template slot-scope="scope">
                  <span v-if="scope.row.language === 0">C</span>
                  <span v-if="scope.row.language === 1">C++</span>
                  <span v-if="scope.row.language === 2">Python3</span>
                </template>
              </el-table-column>
              <el-table-column label="耗时">
                <template slot-scope="scope">
                  <span>{{ scope.row.time_cost }}ms</span>
                </template>
              </el-table-column>
              <el-table-column label="内存">
                <template slot-scope="scope">
                  <span>{{ scope.row.memory_cost / 1024 }}kb</span>
                </template>
              </el-table-column>

              <el-table-column prop="created_time" label="提交时间" width="200">
              </el-table-column>
              <!-- show-overflow-tooltip -->
              <el-table-column label="状态" width="80px">
                <template slot-scope="scope">
                  <el-tag size="mini" :color="programStateEnum[scope.row.result].classifyColor" style="color:#fff;borderColor:transparent">{{programStateEnum[scope.row.result].classifyLabel}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="score" label="得分" fixed="right">
                <template slot-scope="scope">
                  <span v-if="scope.row.result === 6">--</span>
                  <span v-else @click.stop="detailsScope(scope.row)" style="cursor: pointer; color:blue">{{ scope.row.score }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="fr codeStyle" style="width:calc(50% - 12px);border-left: 2px solid #f2f6fc; min-height: 100vh; padding-left: 10px;padding-right: 10px;">
          <div style="margin-top: 12px;overflow-y: auto;border-radius:5px;">
            <code-mirror1 v-model="code1" style="height: 98vh;font-size: 16px;"></code-mirror1>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="测试点信息" :visible.sync="dialogVisible2" width="80%">
      <div slot='title'>
        <span style="font-size:16px;margin-right:5px">测试点信息</span>
        <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
          <div slot="content">
            AC：Accept，程序通过<br />
            WA：Wrong Answer，答案错误<br />
            RE：Runtime Error，运行时错误<br />
            TLE：Time Limit Exceeded，超出时间限制<br />
            MLE：Memory Limit Exceeded，超出内存限制<br />
            OLE：Output Limit Exceeded，输出超过限制<br />
            CE：Compile Error，编译错误<br />
          </div>
          <i class="el-icon-question" style="font-size:16px;color:#666"></i>
        </el-tooltip>
      </div>
      <div style="margin-top:20px">
        <ul style="overflow: hidden;">
          <li v-for="(item, index) in textInfo2" :key="index" class="fl liListStyle">
            <div class="box1 clearfix" :style="{'border-color':programStateEnum[item.result].color}">
              <div class="fixed-left" :style="{'background-color':programStateEnum[item.result].color}">
                <span>{{ "#" + (index + 1 + "") }}</span>
                <div>{{programStateEnum[item.result].en}}</div>
              </div>
              <!-- <div class="fl">{{ item.real_time }}ms /</div> -->
              <div class="fl" v-if="Object.keys(item).includes('cpu_time')">{{ item.cpu_time }}ms/</div>
              <div class="fl" v-if="Object.keys(item).includes('memory')">{{ item.memory / 1024 }}kb</div>

              <div class="fr">
                <div v-if="item.result === 0" class="el-icon-success" style="color: #67C23A; font-size: 14px;"></div>
                <div v-else class="el-icon-error" style="color: #F56C6C; font-size: 14px;"></div>
              </div>
              <div class="fr" style="margin-right:10px">{{ item.score }}分</div>
              <div class="fr" style="margin-right:10px;color: #409EFF; cursor: pointer;" @click="downloadFilesAndCreateZip(item, index)" v-if="item.result != 0 && ($store.state.user.identity === 2?$store.state.user.userInfo.ojTestcaseAuth:true)">
                下载
              </div>
              <div class="fr" style="margin-right:10px;color: #409EFF; cursor: pointer;" @click="look(item, index)" v-if="item.result != 0 && ($store.state.user.identity === 2?$store.state.user.userInfo.ojTestcaseAuth:true)">
                查看
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog title="测试点信息" :visible.sync="dialogVisible3" width="80%" @close="closeDialog">
      <div style="height: calc(50vh - 10px); padding-bottom: 10px; ">
        <span style="font-weight: bold;">{{ "#" + indexcode }} 测试用例</span>
        <div style="margin-top:10px;height: 100%; overflow: hidden;">
          <div class="fl" style="width: calc(50% - 20.5px);height: 100%; padding-left:10px;padding-right: 10px;overflow-x:auto; overflow-y: auto;">
            <div style="font-weight: 600;">输入用例:</div>
            <div style="main_top:10px">
              <span style="white-space:pre">{{ inTXt }}</span>
            </div>
          </div>
          <div class="fl" style="width: 1px; background: #ccc;overflow-x: auto;height: 100%"></div>
          <div class="fl" style="width: calc(50% - 20.5px);height: 100%;padding-left:10px;padding-right: 10px;overflow-x: auto;overflow-y: auto;">
            <div style="font-weight: 600;">输出用例:</div>
            <div style="main_top:10px">
              <span style="white-space:pre">{{ outTxt }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--ChatGPT-->
    <el-drawer title="Ai助手 - P仔" :visible.sync="drawer1" :with-header="false" size="50%">
      <div style="overflow-y: scroll;">
        <div style="text-align: center;margin-top:20px;color:#5e8ff8;font-size: 24px;font-weight: bold;">
          与Ai对话
        </div>
        <div style="text-align: center;margin-top:0px;color:#c7c8ca;font-size: 14px;font-weight: bold;">
          输入你关于C++的问题
        </div>

        <div style="padding:20px;">
          <el-input type="textarea" :rows="8" maxlength="5000" show-word-limit placeholder="你有什么问题，我都可以回答你哦！" v-model="request_info1">
          </el-input>
        </div>

        <div style="text-align:center;">
          <el-button size="small" type="primary" @click="generate_ai" :loading="loading">立即提问</el-button>

          <el-button size="small" @click="ResetAi">重置<i class="el-icon-delete el-icon--right"></i></el-button>
        </div>

        <div style="text-align: center;margin-top: 20px;border:1px solid #d9dde5;margin: 20px;border-radius: 10px;padding:20px;">
          <div v-if="!streamCache1">
            <el-image style="width:20%;" class="contant_img_2" src="https://wugecdn.steam.fun/resources/static/AI_A.png" fit="fill"></el-image>
          </div>

          <div v-if="!streamCache1" style="font-size: 18px;font-weight: bold;">
            等待您的输入
          </div>
          <div v-if="!streamCache1">点击提问按钮开始吧</div>

          <mavon-editor :style="{ 'min-height': '0px' }" preview-background="transparent" v-model="ai_text" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>

          <!--
          <div
            v-if="streamCache1"
            style="text-align:left;font-size: 14px;"
            v-html="ai_text"
          ></div>
-->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import CodeMirror from "@/pages/OJ/components/CodeMirror";
import CodeMirror1 from "@/components/CodeMirror";

import {
  getOjProblemInfoById,
  createSubmission,
  getOjSubmissionInfo,
  getUserOjSubmissionList,
  getOneUserOjSubmissionListForTeam,
  createRunRecord,
  getOjRunRecordInfo,
  getTestcaseDownloadNum,
  getTestcaseViewNum,
  getGhatGptToken,
} from "@/api/educational.js";
import { api_stuStarGrantGrantOjProblem } from '@/api/javaApi'
import Clipboard from "clipboard";
import Prism from "prismjs";

// 在Vue组件中引入markdown-it

import axios from "axios";
import OSS from "ali-oss";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  components: {
    CodeMirror,
    CodeMirror1,
  },
  data() {
    return {
      disabled3: false,
      code1: "",
      dialogVisible3: false,
      zipTxt: "",
      height: "0px",
      error_info: "",
      result1: null,
      activeName1: "first1",
      output: "",
      intervalcounter1: 0,
      runRecordId: "",

      SamplesTxt: null,
      scrollerHeight: "calc(100vh - 230px) !important",
      marginTop: "25px 20px 16px 20px",
      isshow2: false,
      desc: "",
      dialogVisible1: false,

      textInfo: [],
      textInfo1: [],

      textInfo2: [],

      dialogVisible2: false,
      page_no: 1,
      page_size: 20,
      total: 20,
      tableData5: [],
      drawer: false,
      intervalcounter: 0,
      isshow1: false,
      ioiUserCoutestProblemSubmissionCount: "",
      errrorInfo: "",
      tableData: [],
      result: null,
      msg: "",
      clearTimeSet: null,
      disabled1: false,
      disabled2: false,

      problem_id: "",
      samples: [],
      detailsFrom: {
        code: "",
        title: "",
      },
      num: 8,
      num2: 16,
      languagesList: [],
      arr1: [],
      languages1: [
        {
          id: "0",
          label: "c",
        },
        {
          id: "1",
          label: "c++",
        },
        {
          id: "2",
          label: "Python3",
        },
      ],

      code: "",
      language: "0",
      submissionId: 0,
      dialogVisible: false,

      //AI题解
      drawer1: false,
      api_key: "",

      //chatgpt配置
      loading: false,
      streamCache: "",
      streamCache1: "",
      messages: [],
      error_message: "",
      errorlist: [], //问题列表
      test_case_id: "",
      inTXt: "",
      outTxt: "",
      indexcode: "",

      //GPT提示词
      request_info: "",
      request_info1: "",
      auto_error: false,

      ai_text: "",

      //庆祝特效
      showeffect: false,
      effect_imgurl: "https://wugecdn.steam.fun/resources/static/oj/oj_%E9%94%99%E8%AF%AF%E5%95%A6.png", // 默认是错误图
      programStateEnum: {
        '-2': {
          label: '编译失败',
          en: 'CE', // Compile Error
          color: 'rgb(255, 132, 0)',
          classifyLabel: '编译失败',
          classifyColor: 'rgb(255, 132, 0)',
        },
        '-1': {
          label: '程序输出不正确',
          en: 'WA', // Wrong Answer
          color: 'rgb(252, 57, 48)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        0: {
          label: '程序输出正确',
          en: 'AC', // Accept
          color: 'rgb(0, 199, 0)',
          classifyLabel: '正确',
          classifyColor: 'rgb(0, 199, 0)',
        },
        1: {
          label: '时间超限',
          en: 'TLE', // Time Limit Exceeded
          color: 'rgb(0, 35, 68)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        2: {
          label: '时间超限',
          en: 'TLE', // Time Limit Exceeded
          color: 'rgb(0, 35, 68)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        3: {
          label: '内存超限',
          en: 'MLE', // Memory Limit Exceeded
          color: 'rgb(0, 0, 145)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        4: {
          label: '程序运行错误',
          en: 'RE', // Runtime Error
          color: 'rgb(170, 52, 214)',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        5: {
          label: '系统错误',
          en: '-',
          color: '#999', // rgb(255, 213, 0)
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        6: {
          label: '等待测评',
          en: '-',
          color: '#999',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        7: {
          label: '测评中',
          en: '-',
          color: '#999',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        8: {
          label: '部分输出正确',
          en: '-',
          color: '#999',
          classifyLabel: '错误',
          classifyColor: 'rgb(252, 57, 48)',
        },
        999: {
          label: '',
          en: '-',
          color: '#999',
          classifyLabel: '未知错误',
          classifyColor: '#999',
        },
      },
      grantStarCoinInfo: {
        state: 0, //状态（1 发放成功 2 已发放过 3 未开启发放）
        starNum: 0, // 发放数量
      }
    };
  },
  watch: {
    code(newVal, oldVal) {
      console.log(newVal, 222344);
      console.log(oldVal, 222344);
    },
  },
  created() {
    this.problem_id = this.$route.query.id;

    console.log(this.$route.query.txt, 787845);

    if (this.$route.query.type1 === "game1") {
      console.log(this.$route.query.languages, 1122455);
      this.languagesList = JSON.parse(this.$route.query.languages);
      this.languagesList.sort();
      console.log(this.languages1, 123456789);

      if (this.$route.query.txt === undefined) {
        if (this.languagesList.includes("1")) {
          this.language = "1";
        } else {
          this.language = this.languagesList[0];
        }
      } else {
        this.language = this.$route.query.language;
      }

      this.languagesList.map((item) => {
        console.log(item, 12346);
        let obj = this.languages1.find(function (e) {
          return e.id === item;
        });
        console.log(obj, 1474411);
        this.arr1.push(obj);
      });
      console.log(this.arr1, 1474411);
      console.log(this.languagesList, 123456798);
    }
  },
  mounted() {
    if (sessionStorage.getItem("auto_error")) {
      if (sessionStorage.getItem("auto_error") == "true") {
        this.auto_error = true;
      } else {
        this.auto_error = false;
      }
    }
    console.log(this.$route.query.type, 5632323);
    console.log(this.$route.query.problemlist_id, 586532);

    console.log(this.$store.state.user.identity, 11232345);
    // Prism.highlightAll();
    this.getOneUserOjSubmissionListForTeam()
    this.getOjProblemInfoById()

    if (
      sessionStorage.getItem("codeTxt") === "" ||
      sessionStorage.getItem("codeTxt") === null
    ) {
      this.code = "";
    } else {
      this.code = sessionStorage.getItem("codeTxt");
    }
  },

  methods: {
    HelpAi() {
      this.auto_error = true;
      this.error_message = "";
      console.log("错误信息");
      console.log(this.errrorInfo);
      this.generate(this.errrorInfo);
    },

    changeautoerror() {
      console.log(this.auto_error, 12345679);
      sessionStorage.setItem("auto_error", this.auto_error);
      if (this.auto_error == true) {
        this.generate(this.errrorInfo);
      }
    },
    ResetAi() {
      this.request_info1 = "";
      this.streamCache1 = "";
      this.ai_text = "";
    },
    lookDetil(val) {
      console.log(val, 12465);
      this.code1 = val.code;
    },
    look(val, index) {
      getTestcaseViewNum().then((res) => {
        if (res.test_case_view_num == -1) {
          this.$message.warning("今日查看次数已用完");
          this.dialogVisible3 = false;
        } else {
          console.log(this.$store.state.user.token, 123465);
          this.inTXt = "";
          this.outTxt = "";
          this.indexcode = index + 1;

          let client;
          let client1;

          axios
            .get("/api/get/aliyun/sts", {
              headers: {
                Authorization: this.$store.state.user.token,
                "X-Requested-With": "XMLHttpRequest",
              },
            })
            .then((res) => {
              client = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              client1 = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              let url = "problem/" + this.test_case_id + "/" + val.input_name;
              let url1 = "problem/" + this.test_case_id + "/" + val.output_name;
              url = client.signatureUrl(url);
              url1 = client1.signatureUrl(url1);
              console.log(url);
              console.log(url1);

              const xhr = new XMLHttpRequest();
              const xhr1 = new XMLHttpRequest();

              xhr.open("GET", url, true);
              xhr.onreadystatechange = () => {
                this.inTXt = xhr.responseText;
              };
              xhr.send();
              xhr1.open("GET", url1, true);
              xhr1.onreadystatechange = () => {
                this.outTxt = xhr1.responseText;
              };
              xhr1.send();
            });

          this.$message.success("剩余查看次数" + res.test_case_view_num);
          this.dialogVisible3 = true;
        }
      });
    },
    downloadFilesAndCreateZip(val, index) {
      console.log(index);
      getTestcaseDownloadNum().then((res) => {
        console.log(res, 123154);
        if (res.test_case_download_num == -1) {
          this.$message.warning("今日下载次数已用完");
        }
        if (res.test_case_download_num != -1) {
          let client2;
          let client3;

          axios
            .get("/api/get/aliyun/sts", {
              headers: {
                Authorization: this.$store.state.user.token,
                "X-Requested-With": "XMLHttpRequest",
              },
            })
            .then((res) => {
              client2 = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              client3 = new OSS({
                region: "oss-cn-zhangjiakou",
                accessKeyId: res.data.AccessKeyId,
                accessKeySecret: res.data.AccessKeySecret,
                stsToken: res.data.SecurityToken,
                bucket: "wugetestcase",
                secure: true,
              });
              let url = "problem/" + this.test_case_id + "/" + val.input_name;
              let url1 = "problem/" + this.test_case_id + "/" + val.output_name;
              let url2 = client2.signatureUrl(url);
              let url3 = client3.signatureUrl(url1);
              console.log(url, 123456);
              console.log(url1, 123456);
              console.log(url2, 1234561);
              console.log(url3, 1234561);
              this.$nextTick(() => {
                this.xiazai(url2, url3, val.input_name, val.output_name);
              });
            });
          this.$message.success("剩余下载次数" + res.test_case_download_num);
        }
      });
    },
    async xiazai(url2, url3, input_name, output_name) {
      console.log(url2);
      console.log(url3);
      //下载压缩包
      const zip = new JSZip();
      const inResult = await axios.get(url2, {
        responseType: "arraybuffer",
      });
      zip.file(input_name, inResult.data);
      const outResult = await axios.get(url3, {
        responseType: "arraybuffer",
      });
      zip.file(output_name, outResult.data);
      zip.generateAsync({ type: "blob" }).then((content) => {
        FileSaver(content, "测试用例.zip");
      });
    },

    closeDialog() {
      this.dialogVisible3 = false;
    },

    copy() {
      console.log(12345);
      var clipboard = new Clipboard(".tags1");
      console.log(clipboard);

      clipboard.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    copy1() {
      console.log(12345);
      var clipboard = new Clipboard(".tags2");
      console.log(clipboard);

      clipboard.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
      });
    },

    async generate(error) {
      console.log("Ai编辑反馈");

      if (!this.auto_error) return;

      this.streamCache = "";
      this.request_info =
        "请帮我看一下这个C++代码为什么编译出错了？并指出错误所在行数\n" + error;

      this.loading = true;

      fetch("https://ai.wugedianxia.cn/api/chat/completions", {
        method: "POST",
        body: JSON.stringify({
          text: this.request_info,
          //sessionId: 894,
          appId: 59,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("gpt_token"),
        },
      }).then((res) => {
        console.log("新人工智能服务器返回");
        console.log(res);

        const reader = res.body.getReader();
        const decoder = new TextDecoder("utf-8");

        let that = this;
        reader.read().then(async function processText(res) {
          //console.log("循环读取信息");
          //console.log(res);

          if (res.done || !that.loading) {
            return;
          }

          const decodeContent = decoder.decode(res.value);

          //console.log("decodeContent");
          //console.log(decodeContent);

          // error
          if (decodeContent.includes(`"error": {\n`)) {
            console.log("账户错误");
            console.log(decodeContent);
            that.loading = false;
            return;
          }

          // done
          if (decodeContent.includes("data: [DONE]")) {
            that.loading = false;
            console.log("回答完成");
            return;
          }

          decodeContent
            .replaceAll("data: ", "")
            .split("\n")
            .filter(Boolean)
            .forEach(async (item) => {
              const itemObj = JSON.parse(item);

              console.log("新服务器回答");
              console.log(itemObj);

              if (!itemObj.data) {
                return;
              }

              const str = itemObj.data;

              if (itemObj.type == "string") {
                that.streamCache += str;
              }

              that.error_message = that.streamCache;
            });

          return reader.read().then(processText);
        });
      });
    },

    //Ai调用函数
    async generate_ai() {
      console.log("新的Ai服务器");

      this.streamCache1 = "";
      this.loading = true;

      fetch("https://ai.wugedianxia.cn/api/chat/completions", {
        method: "POST",
        body: JSON.stringify({
          text: this.request_info1,
          //sessionId: 894,
          appId: 61,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("gpt_token"),
        },
      }).then((res) => {
        console.log("新人工智能服务器返回");
        console.log(res);

        const reader = res.body.getReader();
        const decoder = new TextDecoder("utf-8");

        let that = this;
        reader.read().then(async function processText(res) {
          //console.log("循环读取信息");
          //console.log(res);

          if (res.done || !that.loading) {
            return;
          }

          const decodeContent = decoder.decode(res.value);

          //console.log("decodeContent");
          //console.log(decodeContent);

          // error
          if (decodeContent.includes(`"error": {\n`)) {
            console.log("账户错误");
            console.log(decodeContent);
            that.loading = false;
            return;
          }

          // done
          if (decodeContent.includes("data: [DONE]")) {
            that.loading = false;
            console.log("回答完成");
            return;
          }

          decodeContent
            .replaceAll("data: ", "")
            .split("\n")
            .filter(Boolean)
            .forEach(async (item) => {
              const itemObj = JSON.parse(item);

              console.log("新服务器回答");
              console.log(itemObj);

              if (!itemObj.data) {
                return;
              }

              const str = itemObj.data;

              if (itemObj.type == "string") {
                that.streamCache1 += str;
              }
              that.ai_text = that.streamCache1;
            });

          return reader.read().then(processText);
        });
      });
    },

    ShowChatGPT() {
      // console.log(this.$store.state.user.identity, 111111)
      if (this.$store.state.user.identity === 1) {
        this.drawer1 = true;
        this.getGhatGptToken();
      } else if (this.$store.state.user.identity === 2) {
        console.log(784512312313);
        console.log(this.$store.state.user.userInfo.pauth);
        if (this.$store.state.user.userInfo.pauth == false) {
          this.$message.warning("暂无权限");
        } else {
          this.drawer1 = true;
          this.getGhatGptToken();
        }
      }
      // this.drawer1 = true;
      // this.getGhatGptToken();
    },

    //动态获得GPT-TOKEN
    getGhatGptToken() {
      getGhatGptToken().then((res) => {
        console.log("动态获取GPT");
        console.log(res.chatGptKeyList);
        localStorage.setItem("gpt_token", res.chatGptKeyList[0].key);
      });
    },

    goTopicAnalysis() {
      console.log(this.code, 123465);
      if (this.$store.state.user.identity == "2") {
        console.log(123456);
        this.$store.dispatch("freshUserData").then((res) => {
          console.log(res, 457841);
          if (res.userInfo.ojAnalysisAuth === true) {
            if (this.$route.query.type1 === "tuanduitidan") {
              this.$router.push({
                name: "ojTopicAnalysis",
                query: {
                  oj_problem_id: this.problem_id,
                  code: this.detailsFrom.code,
                  title: this.detailsFrom.title,
                  id: this.$route.query.id,
                  totalSubmissionNum: this.$route.query.totalSubmissionNum,
                  acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
                  contest_id: this.$route.query.contest_id,
                  type1: "tuanduitidan",
                  type: this.$route.query.type,
                  language: this.language,
                  txt: "jx",
                  page_notd: this.$route.query.page_notd,
                  page_sizetd: this.$route.query.page_sizetd,
                  problemlist_id: this.$route.query.problemlist_id,
                  practice: this.$route.query.practice,
                  problemAcceptNum: this.$route.query.problemAcceptNum,
                  problem_num: this.$route.query.problem_num,
                  team: this.$route.query.team,
                  teamProblemlistRelationId: this.$route.query
                    .teamProblemlistRelationId,
                },
              });
            } else if (this.$route.query.type1 === "tidan") {
              console.log(121211, 89898566);
              this.$router.push({
                name: "ojTopicAnalysis",
                query: {
                  oj_problem_id: this.problem_id,
                  code: this.detailsFrom.code,
                  title: this.detailsFrom.title,
                  // id: this.$route.query.id,
                  // totalSubmissionNum: this.$route.query.totalSubmissionNum,
                  // acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
                  // contest_id: this.$route.query.contest_id,
                  // type1: 'problem',
                  language: this.language,
                  // txt: 'jx'
                  id: this.$route.query.id,
                  type1: "tidan",
                  description: this.$route.query.description,
                  problemlist_id: this.$route.query.problemlist_id,
                  practice: "practice",
                  // title: this.$route.query.title,
                  // code: this.$route.query.code,
                  problemAcceptNum: this.$route.query.problemAcceptNum,
                  problem_num: this.$route.query.problem_num,
                  teamProblemlistRelationId: this.$route.query
                    .teamProblemlistRelationId,
                },
              });
            } else if (this.$route.query.type1 === "tuanduiStu") {
              this.$router.push({
                name: "ojTopicAnalysis",
                query: {
                  oj_problem_id: this.problem_id,
                  code: this.detailsFrom.code,
                  title: this.detailsFrom.title,
                  id: this.$route.query.id,
                  totalSubmissionNum: this.$route.query.totalSubmissionNum,
                  acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
                  contest_id: this.$route.query.contest_id,
                  language: this.language,
                  txt: "jx",
                  type1: "tuanduiStu",
                  activeName: this.activeName,
                  page_no: this.page_no,
                  page_size: this.page_size,
                  team: this.$route.query.team,
                  teamProblemlistRelationId: this.$route.query
                    .teamProblemlistRelationId,
                },
              });
            } else if (this.$route.query.type1 === "game1") {
              this.$router.push({
                name: "ojTopicAnalysis",
                query: {
                  id: this.$route.query.id,
                  oj_problem_id: this.problem_id,
                  code: this.detailsFrom.code,
                  title: this.detailsFrom.title,

                  // totalSubmissionNum: this.$route.query.totalSubmissionNum,
                  // acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
                  contest_id: this.$route.query.contest_id,
                  type1: "game",
                  language: this.language,
                  txt: "jx",
                  isShow: this.$route.query.isShow,
                  languages: this.$route.query.languages,

                  oj_contest_id: this.$route.query.oj_contest_id,
                  activeName: "second",
                  end_date: this.$route.query.end_date,
                  rule_type: this.$route.query.rule_type,
                  typetime: this.$route.query.typetime,
                  teamProblemlistRelationId: this.$route.query
                    .teamProblemlistRelationId,
                },
              });
            } else {
              this.$router.push({
                name: "ojTopicAnalysis",
                query: {
                  oj_problem_id: this.problem_id,
                  code: this.detailsFrom.code,
                  title: this.detailsFrom.title,
                  id: this.$route.query.id,
                  totalSubmissionNum: this.$route.query.totalSubmissionNum,
                  acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
                  contest_id: this.$route.query.contest_id,
                  type1: "problem",
                  language: this.language,
                  txt: 'jx',
                  teamProblemlistRelationId: this.$route.query
                    .teamProblemlistRelationId,
                },
              });
            }
            // this.$router.push({
            //   name: 'ojTopicAnalysis',
            //   query: {
            //     oj_problem_id: this.problem_id,
            //     code: this.detailsFrom.code,
            //     title: this.detailsFrom.title,
            //     id: this.$route.query.id,
            //     totalSubmissionNum: this.$route.query.totalSubmissionNum,
            //     acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
            //     contest_id: this.$route.query.contest_id,
            //     type1: 'problem',
            //     language: this.language,
            //     txt: 'jx'
            //   }

            // })
          } else {
            this.$message.warning("无权查看");
          }
        });
      } else {
        console.log(789456);

        if (this.$route.query.type1 === "tuanduitidan") {
          this.$router.push({
            name: "ojTopicAnalysis",
            query: {
              oj_problem_id: this.problem_id,
              code: this.detailsFrom.code,
              title: this.detailsFrom.title,
              id: this.$route.query.id,
              totalSubmissionNum: this.$route.query.totalSubmissionNum,
              acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
              contest_id: this.$route.query.contest_id,
              type1: "tuanduitidan",
              language: this.language,
              txt: "jx",
              type: this.$route.query.type,
              // console.log(this.$route.query.type, 5632323);

              page_notd: this.$route.query.page_notd,
              page_sizetd: this.$route.query.page_sizetd,
              problemlist_id: this.$route.query.problemlist_id,
              practice: this.$route.query.practice,
              problemAcceptNum: this.$route.query.problemAcceptNum,
              problem_num: this.$route.query.problem_num,
              team: this.$route.query.team,
              ProblemLength: this.$route.query.ProblemLength,
              page_no: this.$route.query.page_no,
              page_size: this.$route.query.page_size,
              TableIndex: this.$route.query.TableIndex,
              teamProblemlistRelationId: this.$route.query
                .teamProblemlistRelationId,
            },
          });
        } else if (this.$route.query.type1 === "tidan") {
          console.log(121211, 89898566);
          this.$router.push({
            name: "ojTopicAnalysis",
            query: {
              oj_problem_id: this.problem_id,
              code: this.detailsFrom.code,
              title: this.detailsFrom.title,
              // id: this.$route.query.id,
              // totalSubmissionNum: this.$route.query.totalSubmissionNum,
              // acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
              // contest_id: this.$route.query.contest_id,
              // type1: 'problem',
              language: this.language,
              // txt: 'jx'
              id: this.$route.query.id,
              type1: "tidan",
              description: this.$route.query.description,
              problemlist_id: this.$route.query.problemlist_id,
              practice: "practice",
              // title: this.$route.query.title,
              // code: this.$route.query.code,
              problemAcceptNum: this.$route.query.problemAcceptNum,
              problem_num: this.$route.query.problem_num,
              teamProblemlistRelationId: this.$route.query
                .teamProblemlistRelationId,
            },
          });
        } else if (this.$route.query.type1 === "tuandui") {
          this.$router.push({
            name: "ojTopicAnalysis",
            query: {
              oj_problem_id: this.problem_id,
              code: this.detailsFrom.code,
              title: this.detailsFrom.title,
              id: this.$route.query.id,
              totalSubmissionNum: this.$route.query.totalSubmissionNum,
              acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
              contest_id: this.$route.query.contest_id,
              language: this.language,
              txt: "jx",
              type1: "tuandui",
              activeName: this.activeName,
              page_no: this.page_no,
              page_size: this.page_size,
              team: this.$route.query.team,
              teamProblemlistRelationId: this.$route.query
                .teamProblemlistRelationId,
            },
          });
        } else if (this.$route.query.type1 === "game1") {
          // game1

          this.$router.push({
            name: "ojTopicAnalysis",
            query: {
              id: this.$route.query.id,
              oj_problem_id: this.problem_id,
              code: this.detailsFrom.code,
              title: this.detailsFrom.title,

              // totalSubmissionNum: this.$route.query.totalSubmissionNum,
              // acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
              contest_id: this.$route.query.contest_id,
              type1: "game",
              language: this.language,
              txt: "jx",
              isShow: this.$route.query.isShow,
              languages: this.$route.query.languages,

              oj_contest_id: this.$route.query.oj_contest_id,
              activeName: "second",
              end_date: this.$route.query.end_date,
              rule_type: this.$route.query.rule_type,
              typetime: this.$route.query.typetime,
              teamProblemlistRelationId: this.$route.query
                .teamProblemlistRelationId,
            },
          });
        } else if (this.$route.query.type1 === "recordOJ") {
          this.$router.push({
            name: "ojTopicAnalysis",
            query: {
              oj_problem_id: this.problem_id,
              code: this.detailsFrom.code,
              title: this.detailsFrom.title,
              id: this.$route.query.id,
              type1: "recordOJ",
              language: this.language,
              teamProblemlistRelationId: this.$route.query
                .teamProblemlistRelationId,
            },
          });
        } else if (this.$route.query.type1 === "Gameproblem") {
          this.$router.push({
            name: "ojTopicAnalysis",
            query: {
              oj_problem_id: this.problem_id,
              code: this.detailsFrom.code,
              title: this.detailsFrom.title,
              id: this.$route.query.id,
              language: this.language,
              pageON: this.$route.query.pageON,
              pageSize: this.$route.query.pageSize,
              type1: "Gameproblem",
              gameId: this.$route.query.gameId,
              teamProblemlistRelationId: this.$route.query
                .teamProblemlistRelationId,
            },
          });
        } else {
          this.$router.push({
            name: "ojTopicAnalysis",
            query: {
              oj_problem_id: this.problem_id,
              code: this.detailsFrom.code,
              title: this.detailsFrom.title,
              id: this.$route.query.id,
              totalSubmissionNum: this.$route.query.totalSubmissionNum,
              acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
              contest_id: this.$route.query.contest_id,
              type1: "problem",
              language: this.language,
              txt: 'jx',
              teamProblemlistRelationId: this.$route.query
                .teamProblemlistRelationId,
            },
          });
        }
      }
    },

    Console() {
      this.isshow2 = !this.isshow2;
      if (this.isshow2 === true) {
        this.scrollerHeight = "calc(100vh - 420px) !important";
        this.marginTop = "27px 20px 16px 20px";
      } else {
        this.scrollerHeight = "calc(100vh - 230px) !important";
        this.marginTop = "25px 20px 16px 20px";
      }
      this.desc = this.samples[0].input;
    },
    ChangeSamples(val) {
      console.log(val, 125);
      this.desc = val;
    },
    AddInputSample() {
      console.log(this.samples, 2223);
    },
    test() {
      this.auto_error = false;
      this.errrorInfo = "";
      this.isshow2 = true;
      if (this.isshow2 === true) {
        this.scrollerHeight = "calc(100vh - 420px) !important";
        this.marginTop = "27px 20px 16px 20px";
      } else {
        this.scrollerHeight = "calc(100vh - 230px) !important";
        this.marginTop = "25px 20px 16px 20px";
      }
      if (this.code === "") {
        this.$message.warning("代码不能为空");
        return false;
      }
      createRunRecord({
        problem_id: this.problem_id,
        code: this.code,
        language: this.language,
        input: this.desc,
      }).then((res) => {
        this.runRecordId = res.data.runRecordId;
        console.log(this.runRecordId, 22354);
        this.$nextTick(() => {
          this.getOjRunRecordInfo();
        });
      });
    },
    getOjRunRecordInfo() {
      this.errorlist = [];
      getOjRunRecordInfo({
        run_record_id: this.runRecordId,
      }).then((res) => {
        clearInterval(this.clearTimeSet1);
        if (res.runRecordInfo.result === 6 || res.runRecordInfo.result === 7) {
          this.intervalcounter1++;
          this.disabled1 = true;
          this.disabled3 = true;

          console.log(this.intervalcounter1, 123456);
          this.clearTimeSet1 = setInterval(this.getOjRunRecordInfo, 1000);

          if (this.intervalcounter1 === 20) {
            clearInterval(this.clearTimeSet1);
            this.$message.warning("判题超时");
            this.disabled1 = false;
            this.disabled3 = false;
          }
          console.log(this.intervalcounter1, 123456);
        } else {
          this.disabled1 = false;
          this.disabled3 = false;

          clearInterval(this.clearTimeSet1);
          this.intervalcounter1 = 0;
          let aa = res.runRecordInfo.output.replace(/\n/g, "<br>");

          this.output = aa;
          // this.xxx.name = aa;

          this.activeName1 = "second1";
          this.result1 = res.runRecordInfo.result;
          this.error_info = res.runRecordInfo.error_info;
          this.errrorInfo = res.runRecordInfo.error_info;

          const errors = res.runRecordInfo.error_info.split("cpp:");

          for (let i = 0; i < errors.length; i++) {
            console.log("错误信息");
            console.log(errors[i]);

            if (errors[i].indexOf("error") !== -1) {
              console.log("存在的错误信息");
              console.log(errors[i]);

              if (errors[i].indexOf("/judger") !== -1) {
                this.errorlist.push(errors[i].split("/judger")[0]);
              } else {
                this.errorlist.push(errors[i]);
              }
            }
          }
          if (this.result1 == -2) {
            //this.generate(this.error_info);
          }
        }
      });
    },

    detailsScope(row) {
      console.log(row);
      this.textInfo2 = [];
      this.textInfo = JSON.parse(row.testcases_info);
      var obj = this.textInfo1.map((item, index) => {
        return { ...{ result: 999 }, ...item, ...this.textInfo[index] };
      });
      this.textInfo2 = obj;
      console.log(this.textInfo2, 222111);
      this.dialogVisible2 = true;
    },
    onChangeLang(newLang) {
      this.page_no = 1
      this.language = newLang
      console.log(this.language)
      let params = {
        code: this.$store.state.user.userInfo.code,
        language: newLang,
        problem_id: this.problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        contest_id: this.$route.query.oj_contest_id,
      }
      if (this.$route.query.teamProblemlistRelationId) {
        params.team_problemlist_relation_id = this.$route.query.teamProblemlistRelationId
      }
      const temporaryFun =
        this.$route.query.type1 === 'tuanduitidan' &&
          this.$store.state.user.identity === 2
          ? getOneUserOjSubmissionListForTeam
          : getUserOjSubmissionList
      temporaryFun(params).then((res) => {
        console.log(res)
        this.tableData = res.submissionList
        if (this.tableData.length === 0) {
          this.code = "";
        }
        if (
          sessionStorage.getItem("codeTxt") === "" ||
          sessionStorage.getItem("codeTxt") === null
        ) {
          if (this.tableData.length > 0) {
            this.code = this.tableData[0].code;
            this.language = this.tableData[0].language.toString();
            // this.tableData.map((item) => {
            //   console.log(item, 12189676)
            //   this.code = item.code
            //   this.language = item.language.toString()
            // })
          } else {
            if (this.language === "0") {
              console.log(JSON.parse(this.detailsFrom.template)[0], 111);
              if ("0" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[0].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }

            if (this.language === "1") {
              if ("1" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[1].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }
            if (this.language === "2") {
              if ("2" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[2].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
            }
          }
        } else {
          this.code = sessionStorage.getItem("codeTxt");
        }
      });
    },
    oncdata(val) {
      console.log(val, 123465);
      this.code = val;
      // if (sessionStorage.getItem('codeTxt') == '') {
      //   this.code = val;

      // } else {
      //   this.code = sessionStorage.getItem('codeTxt')
      // }
    },
    getOneUserOjSubmissionListForTeam() {
      if (this.$route.query.txt === undefined) {
        let params = {
          code: this.$store.state.user.userInfo.code,
          problem_id: this.problem_id,
          page_no: this.page_no,
          page_size: this.page_size,
          contest_id: this.$route.query.oj_contest_id,
        }
        if (this.$route.query.teamProblemlistRelationId) {
          params.team_problemlist_relation_id = this.$route.query.teamProblemlistRelationId
        }

        const temporaryFun =
          this.$route.query.type1 === 'tuanduitidan' &&
            this.$store.state.user.identity === 2
            ? getOneUserOjSubmissionListForTeam
            : getUserOjSubmissionList
        temporaryFun(params).then((res) => {
          console.log(res, 852323)
          this.tableData = res.submissionList
          if (
            sessionStorage.getItem("codeTxt") == "" ||
            sessionStorage.getItem("codeTxt") === null
          ) {
            if (this.tableData.length > 0) {
              this.code = this.tableData[0].code;
              this.language = this.tableData[0].language.toString();

              // this.language = this.tableData[0].language.toString()
              // this.tableData.map((item) => {
              //   console.log(item.code)
              //   // this.code = item.code
              //   this.language = item.language.toString()
              // })
            }
          } else {
            this.code = sessionStorage.getItem("codeTxt");
          }
        });
      } else {
        let params = {
          code: this.$store.state.user.userInfo.code,
          language: this.$route.query.language,
          problem_id: this.problem_id,
          page_no: this.page_no,
          page_size: this.page_size,
          contest_id: this.$route.query.oj_contest_id,
        }
        if (this.$route.query.teamProblemlistRelationId) {
          params.team_problemlist_relation_id = this.$route.query.teamProblemlistRelationId
        }
        const temporaryFun =
          this.$route.query.type1 === 'tuanduitidan' &&
            this.$store.state.user.identity === 2
            ? getOneUserOjSubmissionListForTeam
            : getUserOjSubmissionList
        temporaryFun(params).then((res) => {
          console.log(res)
          this.tableData = res.submissionList
          if (
            sessionStorage.getItem("codeTxt") == "" ||
            sessionStorage.getItem("codeTxt") === null
          ) {
            if (this.tableData.length > 0) {
              this.code = this.tableData[0].code;
              this.language = this.tableData[0].language.toString();
            }
          } else {
            this.code = sessionStorage.getItem("codeTxt");
          }
        });
      }
    },
    GoSubmitRecords() {
      this.page_no = 1
      this.drawer = true
      let params = {
        code: this.$store.state.user.userInfo.code,
        problem_id: this.problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        contest_id: this.$route.query.oj_contest_id,
      }
      if (this.$route.query.teamProblemlistRelationId) {
        params.team_problemlist_relation_id = this.$route.query.teamProblemlistRelationId
      }
      const temporaryFun =
        this.$route.query.type1 === 'tuanduitidan' &&
          this.$store.state.user.identity === 2
          ? getOneUserOjSubmissionListForTeam
          : getUserOjSubmissionList
      temporaryFun(params).then((res) => {
        console.log(res)
        this.tableData = res.submissionList
        if (this.tableData.length != 0) {
          console.log(this.tableData[0].code, 123456);
          this.code1 = this.tableData[0].code;
          console.log(this.code1, 123456);
          this.$nextTick(() => {
            this.$refs.subMitList.setCurrentRow(this.tableData[0]);
          });
        }
        this.total = res.total;
      });

      // const { href } = this.$router.resolve({
      //   name: 'SubmitRecords',
      //   query: {
      //     problem_id: this.problem_id
      //   }
      // });
      // window.open(href, '_blank');
    },
    handleCurrent(val) {
      this.page_no = val
      let params = {
        code: this.$store.state.user.userInfo.code,
        problem_id: this.problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        contest_id: this.$route.query.oj_contest_id,
      }
      if (this.$route.query.teamProblemlistRelationId) {
        params.team_problemlist_relation_id = this.$route.query.teamProblemlistRelationId
      }
      const temporaryFun =
        this.$route.query.type1 === 'tuanduitidan' &&
          this.$store.state.user.identity === 2
          ? getOneUserOjSubmissionListForTeam
          : getUserOjSubmissionList
      temporaryFun(params).then((res) => {
        this.tableData = res.submissionList
        this.total = res.total
      })
    },
    submit(type) {
      this.auto_error = false;
      this.errrorInfo = "";

      if (!this.code) {
        this.$message.warning("代码不能为空");
        var mp3Url = "";
        var player = null;
        mp3Url =
          "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/mp3/wrong.mp3";
        player = new Audio(mp3Url);
        player.play(); //播放 mp3这个音频对象
        return;
      }

      let params = {
        problem_id: this.problem_id,
        code: this.code,
        language: this.language,
        shared: 1,
        oj_contest_id: this.$route.query.oj_contest_id,
        if_judge: type === 'save' ? 0 : 1 // 保存的时候if_judge填0，提交的时候填1
      }
      if (this.$route.query.teamProblemlistRelationId) {
        params.team_plist_id = this.$route.query.teamProblemlistRelationId
      }
      createSubmission(params).then((res) => {
        console.log(res)
        console.log(res.data.ioiUserCoutestProblemSubmissionCount, 2222)
        this.submissionId = res.data.submissionId
        this.ioiUserCoutestProblemSubmissionCount =
          res.data.ioiUserCoutestProblemSubmissionCount;
        this.isshow1 = true;
        if (type === 'submit') {
          this.$nextTick(() => {
            this.getOjSubmissionInfo();
          });
        } else {
          this.$message.success('已保存')
        }
      });
    },
    getOjSubmissionInfo() {
      this.errorlist = [];
      clearInterval(this.clearTimeSet);
      getOjSubmissionInfo({
        submission_id: this.submissionId,
      }).then(async (res) => {
        if (res.submission.result === 6 || res.submission.result === 7) {
          this.disabled1 = true;
          this.disabled2 = true;
          this.intervalcounter++;
          console.log(this.intervalcounter, 123456);
          this.clearTimeSet = setInterval(this.getOjSubmissionInfo, 1000);

          if (this.intervalcounter === 20) {
            clearInterval(this.clearTimeSet);
            this.$message.warning("判题超时");
            this.disabled1 = false;
            this.disabled2 = false;
          }

          console.log(this.intervalcounter, 123456);
        } else {
          clearInterval(this.clearTimeSet);

          console.log(this.intervalcounter, 123456);
          this.intervalcounter = 0;
          this.disabled1 = false;
          this.disabled2 = false;

          this.errrorInfo = res.submission.error_info;

          this.result = res.submission.result;

          const errors = res.submission.error_info.split("cpp:");

          for (let i = 0; i < errors.length; i++) {
            console.log("错误信息");
            console.log(errors[i]);

            if (errors[i].indexOf("error") !== -1) {
              console.log("存在的错误信息");
              console.log(errors[i]);

              if (errors[i].indexOf("/judger") !== -1) {
                this.errorlist.push(errors[i].split("/judger")[0]);
              } else {
                this.errorlist.push(errors[i]);
              }
            }
          }
          if (this.result === -2) {
            //this.generate(this.errrorInfo);
          }

          if (this.$route.query.type1 != "game1") {
            if (
              this.$route.query.rule_type != 2 &&
              !this.disabled1 &&
              this.code !== ""
            ) {
              /**
               * 0:恭喜你通过了这道题
               * -2:编译失败
               * -1:程序输出不正确
               * 1:时间超限
               * 2:时间超限
               * 3:内存超限
               * 4:程序运行错误
               * 5:系统错误
               * 6:等待测评
               * 7:测评中
               * 8:部分输出正确
               */
              // const errStateList = [-2, -1, 1, 2, 3, 4, 5, 6, 7, 8] // 错误
              if (this.result === 0) { // 正确
                if (this.$store.state.user.identity === 2) {
                  this.grantStarCoinInfo = await this.methodStuStarGrantGrantOjProblem(res.submission.problem_id);
                }
                this.effect_imgurl =
                  "https://wugecdn.steam.fun/resources/static/oj/oj_success.png";
              } else {
                this.effect_imgurl =
                  "https://wugecdn.steam.fun/resources/static/oj/oj_%E9%94%99%E8%AF%AF%E5%95%A6.png";
              }
              if (!this.errrorInfo) { // 如果没有错误的诊断再提示图片
                this.showeffect = true;
                setTimeout(() => {
                  this.showeffect = false;
                }, 2000); // 1秒后隐藏庆祝特效
              }
            }
          }

          if (this.errrorInfo != "" && this.$route.query.rule_type != 2) {
            this.dialogVisible = true;
          }

          var mp3Url = "";
          var player = null;
          if (this.$route.query.rule_type != 2) {
            if (this.result == 0) {
              mp3Url =
                "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/mp3/coin.mp3";
              if (this.grantStarCoinInfo.state === 1 && this.grantStarCoinInfo.starNum) {
                mp3Url = "https://wugecdn.steam.fun/resources/static/StarCenter/star.MP3";
              }
              player = new Audio(mp3Url);
              player.play(); //播放 mp3这个音频对象
            } else {
              mp3Url =
                "https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/mp3/wrong.mp3";
              player = new Audio(mp3Url);
              player.play(); //播放 mp3这个音频对象
            }
          }
        }
      });
    },

    redo() {
      if (this.language === "0") {
        console.log(JSON.parse(this.detailsFrom.template)[0], 111);
        if ("0" in JSON.parse(this.detailsFrom.template)) {
          this.code = JSON.parse(this.detailsFrom.template)[0].match(
            /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
          )[1];
        } else {
          this.code = "";
        }
        // this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
      }

      if (this.language === "1") {
        if ("1" in JSON.parse(this.detailsFrom.template)) {
          this.code = JSON.parse(this.detailsFrom.template)[1].match(
            /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
          )[1];
        } else {
          this.code = "";
        }
        // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
      }
      if (this.language === "2") {
        if ("2" in JSON.parse(this.detailsFrom.template)) {
          this.code = JSON.parse(this.detailsFrom.template)[2].match(
            /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
          )[1];
        } else {
          this.code = "";
        }
        //this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
      }
      // if (this.language === '0') {
      //   this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

      // }
      // if (this.language === '1') {
      //   this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

      // }
      // if (this.language === '2') {
      //   this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

      // }
    },
    getOjProblemInfoById() {
      getOjProblemInfoById({
        problem_id: this.problem_id,
      }).then((res) => {
        console.log(res, 111);
        this.test_case_id = res.ojProblemInfo.test_case_id;
        console.log(this.test_case_id, 123456);
        this.textInfo1 = JSON.parse(res.ojProblemInfo.test_case_score);
        if (this.$route.query.type1 != "game1") {
          this.languagesList = JSON.parse(res.ojProblemInfo.languages);
          this.languagesList.sort();
          if (this.$route.query.txt === undefined) {
            if (this.languagesList.includes("1")) {
              this.language = "1";
            } else {
              this.language = this.languagesList[0];
            }
          } else {
            this.language = this.$route.query.language;
          }
          this.languagesList.map((item) => {
            console.log(item, 12346);
            let obj = this.languages1.find(function (e) {
              return e.id === item;
            });
            console.log(obj, 1474411);
            this.arr1.push(obj);
          });
          console.log(this.arr1, 1474411);
          console.log(this.languagesList, 123456798);
        }
        this.detailsFrom = res.ojProblemInfo;
        console.log(res.ojProblemInfo.attachment_url, 565623);
        if (res.ojProblemInfo.attachment_url === null) {
          this.zipTxt = "";
        } else {
          this.zipTxt = res.ojProblemInfo.attachment_url
            .split("/")
            .slice(-1)[0]
            .split("-")
            .slice(-1)[0];
        }
        console.log(this.detailsFrom, 456562332);
        if (this.detailsFrom.description_show_type === 1) {
          this.$nextTick(() => {
            Prism.highlightAll();
            window.MathJax &&
              window.MathJax.Hub.Queue(
                [
                  "Typeset",
                  window.MathJax.Hub,
                  document.getElementsByClassName("mj"),
                ],
                function () {
                  //to do something   公式重新渲染完成后执行这个回调函数
                }
              );
          });
        }
        // Prism.highlightAll();
        // this.$nextTick(() => {
        //   window.MathJax && window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, document.getElementsByClassName('mj')], function () {
        //     //to do something   公式重新渲染完成后执行这个回调函数
        //   });
        // })

        this.samples = JSON.parse(res.ojProblemInfo.samples);
        this.desc = this.samples[0].input;
        console.log(this.tableData, 222);
        if (
          sessionStorage.getItem("codeTxt") == "" ||
          sessionStorage.getItem("codeTxt") === null
        ) {
          if (this.tableData.length > 0) {
            this.code = this.tableData[0].code;
            this.language = this.tableData[0].language.toString();
            console.log(this.language, 112212);

            // this.tableData.map((item) => {
            //   console.log(item.code)
            //   this.code = item.code
            //   this.language = item.language.toString()
            // })
          } else {
            if (this.language === "0") {
              console.log(JSON.parse(this.detailsFrom.template)[0], 111);
              if ("0" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[0].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }

            if (this.language === "1") {
              if ("1" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[1].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }
            if (this.language === "2") {
              if ("2" in JSON.parse(this.detailsFrom.template)) {
                this.code = JSON.parse(this.detailsFrom.template)[2].match(
                  /\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/
                )[1];
              } else {
                this.code = "";
              }
              //this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';
            }
          }
        } else {
          this.code = sessionStorage.getItem("codeTxt");
        }
      });
    },
    DownloadFile() {
      console.log(this.detailsFrom.attachment_url, 1512121);

      window.open(this.detailsFrom.attachment_url, "_blank");
    },
    handleFullScreen1() {
      if (this.num2 === 16) {
        this.num = 0;
        this.num2 = 24;
      } else {
        this.num = 8;
        this.num2 = 16;
      }
    },
    // 全屏方法
    handleFullScreen() {
      if (this.num === 8) {
        this.num = 24;
        this.num2 = 0;
      } else {
        this.num = 8;
        this.num2 = 16;
      }
    },
    gobackrecordOJ() {
      this.$router.push({
        name: "recordOJ",
        // query: {
        //   pageOn: this.$route.query.pageOn,
        //   pageSize: this.$route.query.pageSize,
        // },
      });
    },
    goback() {
      if (this.$route.query.type1 === "tuandui") {
        console.log(this.$route.query.team, 1212121111111);
        this.$router.push({
          name: "teamDetails",
          query: {
            activeName: "second",
            team: this.$route.query.team,
            page_no: this.$route.query.page_no,
            page_size: this.$route.query.page_size,
            teamProblemlistRelationId: this.$route.query
              .teamProblemlistRelationId,
          },
        });
      } else if (this.$route.query.type1 === "tuanduiStu") {
        console.log(this.$route.query.team, 1212121111111);
        this.$router.push({
          name: "teamStyDetails",
          query: {
            activeName: "second",
            team: this.$route.query.team,
            page_no: this.$route.query.page_no,
            page_size: this.$route.query.page_size,
            teamProblemlistRelationId: this.$route.query
              .teamProblemlistRelationId,
          },
        });
      } else if (this.$route.query.type1 === "tuanduitidan") {
        console.log(this.$route.query.team, 1212121111111);
        this.$router.push({
          name: "teamListOfUestionsList",
          query: {
            type1: 'tuanduitidan',
            teamProblemlistRelationId: this.$route.query
              .teamProblemlistRelationId,
            page_notd: this.$route.query.page_notd,
            page_sizetd: this.$route.query.page_sizetd,
            problemlist_id: this.$route.query.problemlist_id,
            practice: this.$route.query.practice,
            problemAcceptNum: this.$route.query.problemAcceptNum,
            problem_num: this.$route.query.problem_num,
            title: this.$route.query.title,
            team: this.$route.query.team,
            type: this.$route.query.type,
            ProblemLength: this.$route.query.ProblemLength,
            page_no: this.$route.query.page_no,
            page_size: this.$route.query.page_size,
            TableIndex: this.$route.query.TableIndex,
          },
        });
      } else if (this.$route.query.type1 === "tidan") {
        console.log(1111, 89898566);
        this.$router.push({
          name: "ListOfUestionsList",
          query: {
            id: this.$route.query.id,
            type1: "tidan",
            description: this.$route.query.description,
            problemlist_id: this.$route.query.problemlist_id,
            practice: "practice",
            title: this.$route.query.title,
            code: this.$route.query.code,
            problemAcceptNum: this.$route.query.problemAcceptNum,
            problem_num: this.$route.query.problem_num,
            teamProblemlistRelationId: this.$route.query
              .teamProblemlistRelationId,
          },
        });
      } else {
        this.$router.go(-1);
      }

      // this.$router.go(-1)
    },
    goback2() {
      this.$router.push({
        name: "questionBank",
      });
    },
    gobackproblem() {
      this.$router.push({
        name: "addMatchProblem",
        query: {
          // id: row.id,
          pageON: this.$route.query.pageON,
          pageSize: this.$route.query.pageSize,
          type1: "Gameproblem",
          gameId: this.$route.query.gameId,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback1() {
      this.$router.push({
        name: "matchDetails",
        query: {
          activeName: "second",
          id: this.$route.query.id,
          oj_contest_id: this.$route.query.oj_contest_id,
          isShow: this.$route.query.isShow,
          title: this.$route.query.title,
          type: "ganme",
          languages: this.$route.query.languages,
          end_date: this.$route.query.end_date,
          rule_type: this.$route.query.rule_type,
          typetime: this.$route.query.typetime,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    methodStuStarGrantGrantOjProblem(problemId) {
      return api_stuStarGrantGrantOjProblem({ problemId })
    },
  },
};
</script>

<style lang="scss" scoped>
.box1 {
  position: relative;
  border: 1px solid #fff;
  padding: 15px 15px 15px 65px;
  border-radius: 5px;
  .fixed-left {
    position: absolute;
    left: 0;
    top: 0;
    width: 55px;
    height: 100%;
    color: #fff;
    span {
      display: inline-block;
      padding: 0 5px;
      font-size: 10px;
    }
    div {
      text-align: center;
    }
  }
}

.questionBankDetails {
  height: 100%;
  width: 100%;

  .celebration {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    .celebration-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 200px;
      animation: bounce 1s infinite;
    }
    .grant-top {
      position: relative;
      width: 270px;
      transform: translateY(10px);
      img {
        display: block;
        width: 100%;
      }
      .grant-num {
        position: absolute;
        left: 135px;
        top: 5px;
        color: #fff;
        font-size: 28px;
      }
    }
    .celebration-effect {
      width: 100%;
    }
  }

  @keyframes bounce {
    0% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-20px);
    }

    100% {
      transform: translateY(0);
    }
  }
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.main {
  height: calc(100vh - 150px);
  margin: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.main_top ul {
  width: 100%;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.main_top {
  text-align: center;
}

.main_top li {
  float: left;
  width: 20%;
}

.txt1 {
  color: #606266;
  font-size: 14px;
  font-weight: bold;
}

.txt2 {
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
}

.main-left {
  height: 100%;
  background: #fff;
  padding: 20px;
  height: calc(100vh - 150px);
  box-sizing: border-box;
  overflow-y: auto;
}

.main_cotton div {
  margin-top: 20px;
}

.txt3 {
  font-size: 16px;
  font-weight: bold;
}

.txt4 {
  font-size: 16px;
  font-weight: bold;
  color: #6c91f2;
}

.main-right {
  background: #fff;

  padding-top: 0px;
  padding-right: 0px;
  padding-left: 0px;

  height: calc(100vh - 150px);
  box-sizing: border-box;
  overflow-y: hidden;
}

.editor {
  // height: 90% !important;
}

.main_top ::v-deep .el-icon-monitor:before {
  color: #000;
}

.sample-input {
  width: 45%;
  margin-right: 5%;
}

.main_msg /deep/ .el-alert {
  padding: 5px 16px;
  margin-left: 20px;
}

.main_msg /deep/ .el-alert__closebtn {
  top: 9px;
  right: 8px;
}

/deep/ .main_cotton img {
  max-width: 100%;
}

/deep/.main_cotton ul {
  list-style: auto;
  list-style-type: initial;
  margin-left: 20px;
}

/deep/.main_cotton ol {
  list-style: auto;
  list-style-type: decimal;
  margin: auto;
  padding: auto;
  margin-left: 20px;
}

.liListStyle {
  width: calc(50% - 10px);
  margin-bottom: 10px;
  &:nth-of-type(2n) {
    margin-left: 10px;
  }
}

.Console {
}

// /deep/ .CodeMirror {
//   height: calc(100vh - 230px) !important;
// }
// .CodeMirror1 {
//   height: calc(100vh - 500px) !important;
// }
/deep/ .vue-codemirror {
  height: 100%;
}

/deep/ .cm-s-monokai.CodeMirror {
  height: 98% !important;
}

/deep/ .weeor .el-alert__content {
  padding: 0px;
}

/deep/ .weeor .el-icon-close:before {
  content: "";
}

/deep/ #pane-second1 {
  height: 117px;
  overflow-y: auto;
}

/deep/ .el-tabs--border-card {
  box-shadow: none;
}

/deep/.hljs {
  padding: 20px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  border-radius: 5px !important;
  background-color: #272822 !important;
  color: white !important;
}

/deep/.hljs-string {
  color: #e6a23c !important;
}

/deep/.hljs-meta {
  color: #3a8ee6 !important;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}

/deep/ .codeStyle .CodeMirror-scroll {
  min-height: auto;
  max-height: none;
}

.v-note-wrapper {
  display: block !important;
  position: static !important;
}
</style>
